import { ReactSVG } from "react-svg";

import { OfficePhoneRow } from "services/api/offices/types";
import { Badge } from "ui/components/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const OFFICE_PHONE_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Broj",
    field: "phoneNumber",
    type: ColumnTypes.custom,
    render: (row: OfficePhoneRow) => (
      <div className="text-md font-medium text-slate-600">{row.phoneNumber}</div>
    ),
  },
  {
    title: "Opis",
    field: "description",
    type: ColumnTypes.custom,
    render: (row: OfficePhoneRow) => (
      <span className="text-sm text-slate-500">{row.description}</span>
    ),
  },
  {
    title: "",
    field: "primary",
    type: ColumnTypes.custom,
    render: (row: OfficePhoneRow) =>
      row.primary ? <Badge text="Primarni" variant="info" height="small" /> : <></>,
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: OfficePhoneRow) => (
      <div
        onClick={(e) => handleDeleteClick(e, row.id)}
        className="flex justify-end items-center h-[30px] cursor-pointer"
      >
        <ReactSVG src="/media/icons/trash.svg" className="w-4 h-4 stroke-[#bd0000]" />
      </div>
    ),
  },
];
